import axios from "axios";

export const geoCoder = {
    data: function () {
      return {
          geocodeUrl: 'https://nominatim.openstreetmap.org/search?format=json&q=',
          isLoadingSuggestions: false
      }
    },
    methods: {
        async addressToCoordinates(address, successCallback, errorCallback) {
            if (!address) {
                return null
            }
            try {
                const response = await axios.get("https://nominatim.openstreetmap.org/search", {
                    params: {
                        q: address,
                        format: "json",
                    }
                });
                let returnValue = null;
                if (response.data.length === 0) {
                    successCallback(returnValue)
                } else {
                    returnValue = {
                        y: response.data[0].lat,
                        x: response.data[0].lon,
                    };
                    successCallback(returnValue)
                }
            } catch (err) {
                errorCallback(err)
            }
        },
        async searchByAddress (address, successCallback, errorCallback) {
            if (!address) {
                return null
            }
            this.isLoadingSuggestions = true

            try {
                const response = await axios.get("https://nominatim.openstreetmap.org/search", {
                    params: {
                        q: address,
                        format: "json",
                        addressdetails: 1
                    }
                });
                let returnValue = null;
                if (response.data.length > 0) {
                    returnValue = []
                    response.data.forEach(result => {
                        const addr = result.address;
                        const parsed = {
                            street: addr.road || "",
                            houseNumber: addr.house_number || "",
                            city: addr.city || addr.town || addr.village || "",
                            postalCode: addr.postcode || ""
                        };
                        let text = parsed.street + " " + parsed.houseNumber
                        text += text.length > 1 ? ", " : ""
                        text += parsed.postalCode + " " + parsed.city
                        returnValue.push({
                            lat: result.lat,
                            lon: result.lon,
                            text: text
                        })
                    }
                    )
                    successCallback(returnValue)
                }
            } catch (err) {
                errorCallback(err)
            } finally {
                this.isLoadingSuggestions = false
            }
        },

    }
}
